import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Button } from "@root/shared/components/Button";
import { buttonWrapper, text } from "./styles.css";

type Props = {
  isShow: boolean;
  onClickModalClose: () => void;
  onClickUserHiddenTrigger: () => void;
};

export const UserHiddenConfirmationModal: FC<Props> = ({
  isShow,
  onClickModalClose,
  onClickUserHiddenTrigger,
}) => {
  return (
    <Modal
      isShow={isShow}
      onClose={onClickModalClose}
      headerTitleStyle="none"
      spAppearanceType="center"
      pcWidthType="small"
      footerContentStyle="button"
      footerContent={
        <div className={buttonWrapper}>
          <Button theme="tertiary" onClick={onClickModalClose}>
            いいえ
          </Button>
          <Button theme="secondary" onClick={onClickUserHiddenTrigger}>
            はい
          </Button>
        </div>
      }
    >
      <p className={text}>本当に非表示にしますか？</p>
    </Modal>
  );
};
